import { format, parseISO } from 'date-fns'
import { useCallback } from 'react'
import { useDateLocale } from './useDateLocale'

export type FormatDateType = string | Date | null | undefined

export const useFormat = () => {
  const locale = useDateLocale()
  return useCallback(
    (
      date: FormatDateType,
      formatStr = 'PPPPpp',
      options?: Parameters<typeof format>[2]
    ) => {
      if (!date) return null
      if (typeof date === 'string') date = parseISO(date)
      return format(date, formatStr, {
        locale,
        ...options,
      })
    },
    [locale]
  ) // as typeof format
}
